module.exports = __webpack_public_path__ + "static/10-05bfd3248d33cb3b08b1769d68a4bbb0.jpg";